// import React, { useState } from "react";
//import Grid from '@mui/material/Grid';
//import Grid from '@mui/material/Unstable_Grid2';
// import Container from '@mui/material/Container';
// import { Height } from "@mui/icons-material";


//---------------
//Beautiful search bar 2.

/*
import styles from './playground2.module.css';
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const Playground2 = ({className}) => {     //The curly brackets { className } are part of destructuring in JavaScript/React. Destructuring allows you to extract properties from objects or arrays and assign them to variables.

  return (
    <div className={`${styles.example_component} ${className}`}>
      ExampleComponent
    </div>
  );
};

export default Playground2;
*/

//-------------------------------
/*
import React, { useState , useRef, useEffect} from 'react';
import dayjs from 'dayjs';

function Sample(){
  const [calendarRenderArray, setCalendarRenderArray]=useState([]);

  const [dates, setDates] = useState([]);
  const today = dayjs();
  //------------
  useEffect(()=>{
    //----For laptop----
    //const today = dayjs();
    let indexOfWeekday = today.day();          // 0 for Sunday, 1 for Monday, ..., 6 for Saturday.
    indexOfWeekday = (indexOfWeekday + 6) % 7;      // To make it like - 0 for Monday, 1 for tuesday, 2 for wednesday, 3 for thursday, 4 for friday, 5 for saturday and 6 for sunday.    
    let datesArray = [];

    //let dates = [];
    for (let i = 0; i < 7; i++) {
      datesArray.push(today.subtract(indexOfWeekday - i, 'day').format('D'));
    }
    setDates(datesArray);
  },[]);      // Only re-run the effect if this second parameter changes. Here we have to give a state if we are to give something. If nothing given (as in if it is left blank), it will re-run the effect everytime there is some change (any change).

  const weekdayNamesAndDates = [['Monday',dates[0]], ['Tueday',dates[1]], ['Wednesday',dates[2]], ['Thursday',dates[3]], ['Friday',dates[4]], ['Saturday',dates[5]], ['Sunday',dates[6]]];
  //---------------

  function convertTimeToCalendarGridNumber(backendGivenDay, backendGivenHour, backendGivenMinute){
    //-----Getting columnNumberFor909Grids based on date for displaying info on each calendar grid.--------------
    //const backendGivenDay = 18;   // 1 to 31.

    const columnNumberFor909Grids = 2+dates.indexOf(backendGivenDay.toString());    //Plus 2 because the timeslot column and dates array starts with 0.
    //console.log("dates ---------> : "+dates);   
    dates.forEach(item=>{
      //console.log(typeof item);
    });

    //console.log("columnNumberFor909Grids : "+columnNumberFor909Grids);    


    //------Getting row number for 909 grids based on date for displaying info on each calendar grid.------------
    //const backendGivenHour = 17;
    //const backendGivenMinute = 30;   //So in each day there are in total (4 x 24 = 96 rows)+(4 x 1 = 4 last rows) = 100 rows.

    const rowNumberFor909Grids = 4*backendGivenHour+(backendGivenMinute/15);
    //console.log("rowNumberFor909Grids : "+rowNumberFor909Grids);


    //------Getting grid number for 909 grids for displaying info on each calendar grid.------------
    const gridNumberFor909Grids = (rowNumberFor909Grids)*9+columnNumberFor909Grids;
    //console.log("gridNumberFor909Grids : "+gridNumberFor909Grids);
    return [gridNumberFor909Grids, columnNumberFor909Grids, rowNumberFor909Grids ];
  }
  //--------------


  function convertTimetoGridOutputArray(array) {
    return array.map(item => {
      const [gNumber, cNumber, rNumber] = convertTimeToCalendarGridNumber(item.day, item.hour, item.minutes);
      return {
        gridNumber: gNumber,
        columnNumber: cNumber,
        rowNumber: rNumber,
        ...item // Spread the original object properties
      };
    });
  }

  const discussAndLearnAreaCalendarSessionArrayProp = [{"day":4, "hour":2, "minutes": 30},{"day":5, "hour":3, "minutes": 0}]

  const sam = convertTimetoGridOutputArray(discussAndLearnAreaCalendarSessionArrayProp);

  const samp = JSON.stringify(sam, null, 2);

  return(
    <div>
      {samp}
    </div>
  )

}

export default Sample;
*/









//--------------------------------










import React, { useState, useEffect, memo} from 'react';
import dayjs from 'dayjs';

const DateDisplay = memo(({ date }) => {
  return <span>{date.format("YYYY-MM-DD hh:mm:ss")}</span>;
});

function Sample(){

  //const [test, setTest] = useState();

  console.log("--------");

  //const today = dayjs();
  //console.log(today);
  //let today = dayjs();
  const [date, setDate] = useState(dayjs());
  const [toggle, setToggle] = useState(false);

  useEffect(()=>{
    console.log("eeeeeeee");
    console.log(toggle);
    const testFunction = () => {
      console.log("Test function called.");
      //today = dayjs();
      setDate(dayjs());
    }

    testFunction();

    // const interval = setInterval(() => {
    //   testFunction();
    // }, 5000);

    //return () => clearInterval(interval);
  },[]);

  return(
    <div>
      {/*Sample {date.format('YYYY-MM-DD hh:mm:ss')} */}
      Sample <DateDisplay date={date} />

      <button onClick={() => setToggle(prev => !prev)}>
        {toggle ? "Toggle is ON" : "Toggle is OFF"}
      </button>
    </div>
  )

}
export default Sample;